import { render } from "./FlowPanelTransition.vue?vue&type=template&id=18a0a467&scoped=true&ts=true"
import script from "./FlowPanelTransition.vue?vue&type=script&lang=ts"
export * from "./FlowPanelTransition.vue?vue&type=script&lang=ts"

import "./FlowPanelTransition.vue?vue&type=style&index=0&id=18a0a467&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a0a467"]])

export default __exports__